var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-sidebar"}},[_c('div',{staticClass:"brand"},[_c('logo-links')],1),_c('app-search',{staticClass:"mb-4"}),_c('recent-applications',{staticClass:"mb-4"}),_c('sidebar-navigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }